import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'c-suite-panel',
  templateUrl: './c-suite.component.html',
  styleUrls: ['./c-suite.component.css']
})
export class CSuiteComponent {

  @Input() header = "";
  @Input() collapsed = false;
  @Output() collapsedChange: EventEmitter<boolean>;
  @Input() visible = false;
  @Input() items = null;


  constructor() {
    this.collapsedChange = new EventEmitter<boolean>();
  }

  onClick() {
    this.collapsedChange.emit(!this.collapsed);
  }
}



// WEBPACK FOOTER //
// ./src/app/profile/panels/c-suite/c-suite.component.ts